import React from 'react';

import Image from 'next/image';

import { themeStyle } from '@repo/ui/theming';
import { H5 } from '@repo/ui-kit/components/core/Typography';

import { FlexColumn } from 'styles/layouts';

import { ImageRow } from './styles';

const companies = [
  {
    alt: 'Ogilvy',
    src: '/images/landing/companies/ogilvy.svg',
    width: 75,
    height: 30,
  },
  {
    alt: 'Netflix',
    src: '/images/landing/companies/netflix.svg',
    width: 84,
    height: 23,
  },
  {
    alt: 'Apple TV',
    src: '/images/landing/companies/appleTV.svg',
    width: 65,
    height: 30,
  },
  {
    alt: 'Harley Davidson',
    src: '/images/landing/companies/harleyDavidson.svg',
    width: 65,
    height: 50,
  },
  {
    alt: 'Warner Bros',
    src: '/images/landing/companies/warner.svg',
    width: 43,
    height: 55,
  },
  {
    alt: 'Milka',
    src: '/images/landing/companies/milka.svg',
    width: 68,
    height: 33,
  },
];

export const Companies: React.FC = () => {
  return (
    <FlexColumn alignItems="center" gap="24px" padding="24px 0">
      {/* fix color using updated colors tags, when they are available */}
      <H5 as="p" color="disabled">
        Trusted by designers at
      </H5>
      <ImageRow>
        {companies.map((company) => (
          <Image
            key={company.alt}
            alt={company.alt}
            color={themeStyle.varInkLightMedium}
            height={company.height}
            src={company.src}
            width={company.width}
          />
        ))}
      </ImageRow>
    </FlexColumn>
  );
};
